import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Tag } from 'antd'
import { FC } from 'react'
import { Audience } from '../../models/Audience'
import { selectAudienceById } from '../../store/AudiencesReducer'
import { useAppSelector } from '../../store/hooks'

type Props = SBModelComponent<Audience> & {
  showTag?: boolean
  showUserCount?: boolean
}

const AudienceTag: FC<Props> = ({ id, model }) => {
  const audience = model ? model : useAppSelector(selectAudienceById(id!))

  if (!audience) return <></>

  return <Tag color={audience.color}>{audience.title}</Tag>
}

type AudienceTagType = { Tag: typeof AudienceTag }

export { AudienceTag, type AudienceTagType }
